import notifierMixin from '@/mixins/notifierMixin';
import { GOAL_CLICK_EMPLOYEE_ADD_BREAK, GOAL_CLICK_EMPLOYEE_ADD_BREAK_BY_FIO } from '@/plugins/metric';

export default {
  computed: {
    /**
     * @description Наличие выбранного перерыва.
     * @type {boolean}
     */
    wasSelectedBreakSlot: ({ selectedBreak }) => !!selectedBreak,
  },
  data() {
    return {
      /**
       * @description Временная шкала перерывов.
       * @type {[from:Array,to:Array]}
       */
      employeeBreakTimeline: { from: [], to: [] },
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      breakInputErrors: {},
      /**
       * @description Выбранный перерыв.
       * @type {any}
       */
      selectedBreak: null,
      employeeBreakAllowedDates: [],
      /**
       * @description Показывать диалог добавления перерывов.
       * @type {boolean}
       */
      isShownEmployeeBreakDialog: false,
      /**
       * @description Идентификатор сотрудника.
       * @type {number|null}
       */
      employeeBreakId: null,
      /**
       * @description Дата в формате ISO.
       */
      employeeBreakIsoDate: '',
    };
  },
  methods: {
    /**
     * @description Обработать добавление перерыва сотруднику.
     * @param {number} employeeId Идентификатор сотрудника.
     * @param {string} date       Дата.
     * @param {any}    request    Запрос.
     * @returns {void}
     */
    onAddEmployeeBreak(employeeId, date, request) {
      const onFail = (response) => {
        this.notifyFail(response.title);
        this.showEmployeeBreakDialog(employeeId, date);
      };
      const onSuccess = ({ message }) => {
        this.notifySuccess(message);
        this.reloadTimetable(this.viewQuery);
        this.closeEmployeeBreakDialog();
      };
      this.$appointmentScheduleGateway.addBreak(employeeId, date, request).then((response) => {
        response.forEach(onSuccess);
        response.forEachLeft(onFail);
      });
    },
    /**
     * @description Открыть форму перерыва.
     * @param {number} employeeId
     * @param {string} isoDate
     */
    openBreakForm(employeeId, isoDate) {
      const onSuccess = ({ timeline }) => {
        this.employeeBreakTimeline = timeline;
        this.employeeBreakId = employeeId;
        this.employeeBreakIsoDate = isoDate;
      };
      this
        .fetchEmployeeTimelineForBreak(employeeId, isoDate)
        .then((result) => result.fold(this.notifyFail, onSuccess));
    },
    /**
     * @description Открыть диалог добавления перерывов сотруднику.
     * @param {number} employeeId
     * @param {string} isoDate
     * @returns {void}
     */
    tryOpenEmployeeAddBreakDialog(employeeId, isoDate) {
      const onSuccess = ({ timeline }) => {
        this.employeeBreakTimeline = timeline;
        this.showEmployeeBreakDialog(employeeId, isoDate);
      };
      this
        .fetchEmployeeTimelineForBreak(employeeId, isoDate)
        .then((result) => result.fold(this.notifyFail, onSuccess));
    },
    /**
     * @description Показать диалог добавления перерывов сотруднику.
     * @param {number} employeeId
     * @param {string} isoDate
     * @returns {void}
     */
    showEmployeeBreakDialog(employeeId, isoDate) {
      this.employeeBreakId = employeeId;
      this.employeeBreakIsoDate = isoDate;
      this.isShownEmployeeBreakDialog = true;
    },
    /**
     * @description Обработать отправку добавленных перерывов.
     * @param {any} request
     * @returns {void}
     */
    onSubmitEmployeeBreak(request) {
      this.onAddEmployeeBreak(this.employeeBreakId, this.employeeBreakIsoDate, request);
      this.addEmployeeBreakByFioReachGoal();
    },
    /**
     * @description Обработать достижение цели нажатия добавления перерыва через ФИО доктора.
     * @return {void}
     */
    addEmployeeBreakByFioReachGoal() {
      this.$goal(GOAL_CLICK_EMPLOYEE_ADD_BREAK_BY_FIO);
    },
    /**
     * @description Обработать достижение цели нажатия сохранения перерыва.
     * @return {void}
     */
    addEmployeeBreakReachGoal() {
      this.$goal(GOAL_CLICK_EMPLOYEE_ADD_BREAK);
    },
    /**
     * @description Получить временную шкалу сотрудника для перерывов.
     * @param {number} employeeId Идентификатор сотрудника.
     * @param {string} isoDate    Дата в формате ISO.
     * @returns {Promise<Either>}
     */
    fetchEmployeeTimelineForBreak(employeeId, isoDate) {
      return this
        .$appointmentScheduleGateway
        .viewEmployeeTimeLine(employeeId, isoDate, null, false);
    },
    /**
     * @description Закрыть форму редактирования перерыва сотрудника.
     * @returns {void}
     */
    closeEditBreakForm() {
      this.needConfirmBeforeClosed[this.$options.BreakEditForm] = false;
      this.selectedBreak = null;
    },
    /**
     * @description Закрыть диалог.
     * @param {any} request
     * @returns {void}
     */
    closeEmployeeBreakDialog() {
      this.employeeBreakId = null;
      this.employeeBreakIsoDate = '';
      this.isShownEmployeeBreakDialog = false;
    },
    /**
     * @description Открыть форму редактирования перерыва сотрудника.
     * @param {string}                                   date     Дата.
     * @param {object} employee Сотрудник.
     * @param {any}                                      slot     Слот.
     * @returns {void}
     */
    openFormEmployeeBreakEdit(date, employee, slot) {
      const yearAndMonth = date.split('-', 2).join('-');
      this.fetchWorkEmployees(date)
        .then((employees) => { this.appointmentWorkEmployees = employees; });
      this.onReloadEmployeeBreakAllowedDates(employee.id, yearAndMonth);
      this.onReloadEmployeeBreakTimeline(employee.id, date);
      this.selectedBreak = {
        date,
        employee,
        endsTime: slot.ends_time,
        id: slot.id,
        note: slot.note,
        startsTime: slot.starts_time,
      };
    },
    /**
     * @description Обработать перезагрузку временной шкалы сотрудника.
     * @param {number} employeeId
     * @param {string} isoDate
     * @returns {void}
     */
    onReloadEmployeeBreakTimeline(employeeId, isoDate) {
      const onSuccess = ({ timeline }) => { this.employeeBreakTimeline = timeline; };
      this
        .fetchEmployeeTimelineForBreak(employeeId, isoDate)
        .then((result) => result.fold(this.notifyFail, onSuccess));
    },
    /**
     * @description Обработать перезагрузку рабочих дней.
     * @param {number} employeeId
     * @param {string} yearAndMonth
     * @returns {void}
     */
    onReloadEmployeeBreakAllowedDates(employeeId, yearAndMonth) {
      const onSuccess = (allowedDates) => {
        this.employeeBreakAllowedDates = allowedDates;
      };
      const onFail = (error) => {
        if (error.title) {
          this.notifyFail(error.title);
        }
        this.employeeBreakAllowedDates = [];
      };
      this
        .$employeeGateway
        .viewWorkDays(employeeId, yearAndMonth, false)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать отмену перерыва.
     * @param {number} breakId Идентификатор перерыва.
     * @returns {Promise<Either>}
     */
    async sendCancelBreakRequest(breakId) {
      const result = await this.$appointmentScheduleGateway.cancelEmployeeBreak(breakId);
      result.forEach(({ message }) => {
        this.closeEditBreakForm();
        this.breakInputErrors = {};
        this.notifySuccess(message);
        this.reloadTimetable(this.viewQuery);
      });
      result.forEachLeft((error) => {
        this.breakInputErrors = error.allCauses();
        if (error.hasCauses() !== true) {
          this.notifyFail(error.getTitle());
        }
      });
      return result;
    },
    /**
     * @description Отправить запрос на редактирование перерыва.
     * @param {EditEmployeeBreakRequest} request Запрос.
     * @returns {Promise<Either>}
     */
    async sendEditBreakRequest(request) {
      const result = await this.$appointmentScheduleGateway.editEmployeeBreak(request);
      result.forEach(({ message }) => {
        this.closeEditBreakForm();
        this.breakInputErrors = {};
        this.notifySuccess(message);
      });
      result.forEachLeft((error) => {
        this.breakInputErrors = error.allCauses();
        if (error.hasCauses() !== true) {
          this.notifyFail(error.getTitle());
        }
      });
      return result;
    },
  },
  mixins: [notifierMixin],
};
